enum CopilotCreativeTemplatesToolName {
  NavigateToCreativeTemplateBuildOrMapTab = 'NavigateToCreativeTemplateBuildOrMapTab',
}

export {CopilotCreativeTemplatesToolName};